import dayjs from "dayjs";

export let formatDate = (value, format) => {
  let data = dayjs(value).format(format);
  if (data.toLowerCase() === "invalid date") data = value;
  return data;
};
